import { Component, inject, OnInit } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MAT_SNACK_BAR_DATA, MatSnackBarActions, MatSnackBarLabel, MatSnackBarRef } from '@angular/material/snack-bar';
import { TypeAlertEnum } from '@shared/enums/type.alert.enum';
import { DataNotificacion } from './interfaces/data.notificacion';

/**
 * Componente personalizado de las notificaciones, se invoca desde el servicio
 *
 * @author Diego Armando Ortiz Bastidas <dortiz@heinsohn.com.co>
 */
@Component({
  selector: 'notificacion',
  standalone: true,
  imports: [MatButtonModule, MatSnackBarLabel, MatSnackBarActions],
  templateUrl: './notificacion.component.html'
})
export class NotificacionComponent implements OnInit {

  // Inyecciones de dependencias
  private _snackBarRef = inject(MatSnackBarRef<NotificacionComponent>);

  /** Define los datos de entrada para la notificación */
  private _data: DataNotificacion = inject(MAT_SNACK_BAR_DATA);

  /** Define el color del tipo de alerta */
  private _alertColor: string;

  /** Define el título de la notificación */
  private _title: string;

  /**
   * Método que verifica que tipo de alerta se especificó,
   * en caso de no coincidir a las opciones del enum se deja como nulo
   *
   * @author Diego Armando Ortiz Bastidas <dortiz@heinsohn.com.co>
   */
  ngOnInit(): void {
    switch (this.data?.typeAlertEnum) {
      case TypeAlertEnum.SUCCESS:
        this._alertColor = 'success';
        this._title = 'Exitoso';
        break;
      case TypeAlertEnum.INFO:
        this._alertColor = 'azul-secundario';
        this._title = 'Informativo';
        break;
      case TypeAlertEnum.WARNING:
        this._alertColor = 'warning';
        this._title = 'Advertencia';
        break;
      case TypeAlertEnum.ERROR:
        this._alertColor = 'error';
        this._title = 'Error';
        break;
      default:
        this._alertColor = 'normal';
        this._title = '';
        break;
    }
  }

  /**
   * Propiedad que devuelve la referencia de la notificación
   *
   * @author Diego Armando Ortiz Bastidas <dortiz@heinsohn.com.co>
   */
  public get snackBarRef(): MatSnackBarRef<NotificacionComponent> {
    return this._snackBarRef;
  }

  /**
   * Propiedad que devuelve la data de la notificación
   *
   * @author Diego Armando Ortiz Bastidas <dortiz@heinsohn.com.co>
   */
  public get data(): DataNotificacion {
    return this._data;
  }

  /**
   * Propiedad que devuelve el color del tipo de alerta
   *
   * @author Diego Armando Ortiz Bastidas <dortiz@heinsohn.com.co>
   */
  public get alertColor(): string {
    return this._alertColor
  }

  /**
   * Propiedad que devuelve el título de la notificación
   *
   * @author Diego Armando Ortiz Bastidas <dortiz@heinsohn.com.co>
   */
  public get title(): string {
    return this._title;
  }

}
